var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3896 34.0052L41.6268 41.4774L38.5053 43.3121L34.2719 35.8487L34.1112 35.5654L33.8791 35.7939L29.7422 39.8671L29.6729 24.0656L43.0822 32.0279L37.5372 33.6419L37.2336 33.7302L37.3896 34.0052ZM29.171 9.2586V13.1848V13.4348H29.421H39.6766C40.1529 13.4348 40.6105 13.6273 40.9487 13.9716C41.287 14.3159 41.4778 14.7839 41.4778 15.2729V23.3752H37.8755V17.361V17.111H37.6255H17.1142H16.8642V17.361V38.2418V38.4918H17.1142H25.0687V42.168H15.063C14.5868 42.168 14.1291 41.9755 13.791 41.6312C13.4527 41.2869 13.2619 40.8188 13.2619 40.3299V29.8895V29.6395H13.0119H9.15962V25.9633H13.0119H13.2619V25.7133V15.2729C13.2619 14.7839 13.4527 14.3159 13.791 13.9716C14.1291 13.6273 14.5868 13.4348 15.063 13.4348H25.3187H25.5687V13.1848V9.2586H29.171ZM4.55735 25.9633V29.6395H0.955078V25.9633H4.55735ZM4.55735 17.611V21.2871H0.955078V17.611H4.55735ZM4.55735 9.2586V12.9348H0.955078V9.2586H4.55735ZM4.55735 0.90625V4.58243H0.955078V0.90625H4.55735ZM12.7619 0.90625V4.58243H9.15962V0.90625H12.7619ZM20.9664 0.90625V4.58243H17.3642V0.90625H20.9664ZM29.171 0.90625V4.58243H25.5687V0.90625H29.171Z",
    fill: "#8978DC",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.2a4d5e765cda7200261b7dc889bcceee.svg";
export { ForwardRef as ReactComponent };